import axiosInstance from "../../utils/AxiosInstance";
import { toast } from "react-toastify";
import { useAuthHeader } from "react-auth-kit";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { toastError, toastSuccess } from "../../utils/utils";

// GET /users
export const useGetUsers = () => {
  const authHeader = useAuthHeader();

  return useQuery({
    queryKey: ["users"],
    queryFn: async () => {
      const res = await axiosInstance.get("/users", {
        headers: { Authorization: authHeader() },
      });
      return res.data;
    },
  });
};

// GET /communications
export const useGetCommunications = () => {
  const user_types = ["Backend", "Prof. Sanitario"];
  const authHeader = useAuthHeader();
  const usersQuery = useGetUsers();

  return useQuery({
    queryKey: ["communications"],
    queryFn: async () => {
      const res = await axiosInstance.get(`/communications`, {
        headers: { Authorization: authHeader() },
      });
      let data = res.data;

      // operations on data
      let coms = [];
      for (let communication of data.communications) {
        // get specified user
        const user = usersQuery.data.users.filter(
          (user) => user.id === communication.user_id
        )[0];

        // add user info
        communication["user_username"] = user.username;
        communication["user_type"] = user.user_type;
        communication["user_email"] = user.email;

        coms.push(communication);
      }

      data["communications"] = [...coms];
      return data;
    },
    enabled: usersQuery.isFetched,
  });
};

// GET /communications/:communication_id
export const useGeCommunicationById = (communication_id) => {
  const authHeader = useAuthHeader();

  return useQuery({
    queryKey: ["communications", communication_id],
    queryFn: async () => {
      const res = await axiosInstance.get(
        `/communications/${communication_id}`,
        {
          headers: { Authorization: authHeader() },
        }
      );
      return res.data;
    },
    enabled: communication_id !== undefined && communication_id !== null,
  });
};

// === POST /communications ===
export const useNewCommunication = () => {
  const authHeader = useAuthHeader();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (newCommunication) => {
      const res = await axiosInstance.post(
        `/communications`,
        newCommunication,
        {
          headers: {
            Authorization: authHeader(),
          },
        }
      );
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries(["communications"]);
      toast.success("Comunicazione inviata con successo!", toastSuccess);
    },
    onError: (data, variables, context) => {
      toast.error("Errore nell'invio della comunicazione", toastError);
    },
  });
};
